/*
 * @Author: LiuMeiYu
 * @Date: 2022-07-23 10:44:31
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2022-07-23 16:23:47
 * @FilePath: \paceed\src\router\index.ts
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Home",
      requireAuth: false,
    },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      title: "About us",
      requireAuth: false,
    },
  },
  {
    path: "/introduction",
    name: "introduction",
    component: () =>
      import(
        /* webpackChunkName: "introduction" */ "../views/IntroductionView.vue"
      ),
    meta: {
      title: "Introduction",
      requireAuth: false,
    },
  },
  {
    path: "/shipping",
    name: "shipping",
    component: () =>
      import(
        /* webpackChunkName: "shipping" */ "../views/ShippingPolicyView.vue"
      ),
    meta: {
      title: "Shipping Policy",
      requireAuth: false,
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(
        /* webpackChunkName: "terms" */ "../views/TermsConditionsView.vue"
      ),
    meta: {
      title: "Terms&Conditions",
      requireAuth: false,
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
    meta: {
      title: "Contact us",
      requireAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title as string;
  } else {
    document.title = "paceed";
  }
});
export default router;
